import React, { Fragment } from 'react'
import { Pill } from '@myxplor/ui'
import { errorStatus, warningStatus, okStatus } from './helper'

export const GovRecordBadges = ({ record }) => (
  <Fragment>
    <h4>ID: {record.gov_id}</h4>
    <ul>
      <li>
        <Pill>{record.type}</Pill>
      </li>
      <li>
        {okStatus(record.status) && record.has_ended ? (
          <Pill>ENDED</Pill>
        ) : (
          <Pill
            error={errorStatus(record.status)}
            warning={warningStatus(record.status)}
          >
            {record.status}
          </Pill>
        )}
      </li>
    </ul>
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/view/badges.jsx